"use client";

import { c as _c } from "react/compiler-runtime";
import React from "react";
import type { ExtendedDrop } from "@/helpers/waves/drop.helpers";
import { DefaultWaveLeaderboardDrop } from "./DefaultWaveLeaderboardDrop";
interface QuorumWaveLeaderboardDropProps {
  readonly drop: ExtendedDrop;
  readonly onDropClick: (drop: ExtendedDrop) => void;
  readonly winningThreshold?: number | null | undefined;
  readonly winningThresholdMinDurationMs?: number | null | undefined;
  readonly isVotingClosed?: boolean | undefined;
  readonly isVotingControlsLocked?: boolean | undefined;
}
export const QuorumWaveLeaderboardDrop: React.FC<QuorumWaveLeaderboardDropProps> = t0 => {
  const $ = _c(7);
  const {
    drop,
    onDropClick,
    winningThreshold,
    winningThresholdMinDurationMs,
    isVotingClosed,
    isVotingControlsLocked
  } = t0;
  let t1;
  if ($[0] !== drop || $[1] !== isVotingClosed || $[2] !== isVotingControlsLocked || $[3] !== onDropClick || $[4] !== winningThreshold || $[5] !== winningThresholdMinDurationMs) {
    t1 = <DefaultWaveLeaderboardDrop drop={drop} onDropClick={onDropClick} winningThreshold={winningThreshold} winningThresholdMinDurationMs={winningThresholdMinDurationMs} isVotingClosed={isVotingClosed} isVotingControlsLocked={isVotingControlsLocked} contentPresentation="quorumCompact" />;
    $[0] = drop;
    $[1] = isVotingClosed;
    $[2] = isVotingControlsLocked;
    $[3] = onDropClick;
    $[4] = winningThreshold;
    $[5] = winningThresholdMinDurationMs;
    $[6] = t1;
  } else {
    t1 = $[6];
  }
  return t1;
};